export default "__VITE_ASSET__CMXN9tpl__"